import { render, staticRenderFns } from "./fToolbar.template?vue&type=template&id=a157115a&lang=pug&"
import script from "./fToolbar.client?vue&type=script&lang=ts&"
export * from "./fToolbar.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a157115a')) {
      api.createRecord('a157115a', component.options)
    } else {
      api.reload('a157115a', component.options)
    }
    module.hot.accept("./fToolbar.template?vue&type=template&id=a157115a&lang=pug&", function () {
      api.rerender('a157115a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fToolbar/fToolbar.component.vue"
export default component.exports